/** StockForge+ brand mark — growth bars with gold trend arrow. */

const ICON_VIEWBOX = "0 0 32 32";

const ICON_MARKUP = `
  <rect width="32" height="32" rx="8" fill="#12151a"/>
  <rect x="6.2" y="16.8" width="5.2" height="9.4" rx="1.1" fill="#22c55e"/>
  <rect x="13.4" y="17.8" width="5.2" height="9.7" rx="1.1" fill="#ef4444"/>
  <rect x="20.6" y="8.2" width="5.2" height="18" rx="1.1" fill="#22c55e"/>
  <path d="M7.2 14.4 11.4 11.2 14.9 13.8 19.6 8.7 23 11.4 26.6 6.2" fill="none" stroke="#f5c518" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M22.55 6.35 26.85 5.55 26.1 9.85z" fill="#f5c518"/>
`;

/** Inline SVG for app headers. */
export function renderStockforgePlusIcon(size = 26, className = "sfe-brand-icon"): string {
  const cls = className ? ` class="${className}"` : "";
  return `<svg${cls} width="${size}" height="${size}" viewBox="${ICON_VIEWBOX}" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">${ICON_MARKUP}</svg>`;
}
